import type { ColorPalette, PaywallFeatureCard } from './types'

export const residential: ColorPalette = {
  black: '#000000',
  blackTranslucent: 'rgba(0, 0, 0, 0.04)',
  blackTransparent: 'rgba(0, 0, 0, 0)',
  blackShadow: 'rgba(0, 0, 0, 0.18)',

  dimGray: '#707070',
  dimGrayLight: '#A6A6A6',
  dimGrayLighter: '#F2F2F2',
  dimGrayLightest: '#E3E0DC',
  darkGrayLighter: '#999999',
  darkGray: '#A9A9A9',
  darkerGray: 'rgba(166, 166, 166, 0.9)',
  neutralGray: '#C3C3C3',
  silver: '#C0C0C0',

  greyCharcoal: '#333333',
  greyDarkest: '#4D4D4D',
  greyDarkerer: '#676464',
  greyDarker: '#767676',
  greyDark: '#939598',
  grey: '#AAAAAA',
  greyLight: '#D9D9D9',
  greyLighter: '#F5F5F5',
  greyLightest: '#F6F6F6',
  gray: '#CACACA',
  grayDeep: '#444444',
  grayBorder: '#D2D2D2',
  graySoft: '#F7F7F7',
  grayLight: '#F8F8F8',
  grayLightest: '#F9F9F9',
  greyDarkHot: '#6B6B6B',
  greyDim: '#9E9E9E',
  grayDimSoft: '#B5B1B1',
  grayDim: '#E8E8E8',
  dimGrey: '#9E9D9D',
  cloudGray: '#E4EAEB',
  warmGrey: '#F0EDED',
  coolGrey: '#EAEBF4',
  alabasterGray: '#FAFAFA',
  white: '#FFFFFF',
  whiteTranslucent: 'rgba(255, 255, 255, 0.2)',
  lightGray: '#DBDBDB',
  lighterGray: '#E0E0E0',
  lightestGray: '#F0EEEC',
  greyBlue: '#F3F7F8',
  greyBlueLight: '#F8FAFB',
  greyLavender: '#9BA1D7',
  greyTranslucent: 'rgba(136, 136, 136, 0.5)',
  greyStrong: 'rgba(136, 136, 136, 0.7)',

  purpleDarker: '#7332c1',
  purpleDark: '#3f51b5',
  purple: '#b94ec6',
  purpleLight: '#D074F5',
  dimPurple: '#A48EC2',
  purpleDarkest: '#5B1CB7',
  softPurple: '#9758FC',
  purpleMuted: '#9F449B',
  periwinkle: '#9A89FF',

  redDarker: '#FF0000',
  redOrange: '#FF2B00',
  redDark: '#9A1920',
  red: '#CD3529',
  redSoft: '#F3E0E0',
  redLight: '#D05147',
  redLighter: '#C78588',
  redLightest: '#FFD4D4',
  redTranslucent: 'rgba(205,53,41,0.5)',
  redPink: '#FFAFAF',
  pinkBright: '#FC36B4',
  dimRed: '#D47068',
  brightRed: '#F33520',
  dimSoftRed: '#FFEBE5',

  orange: '#DF661E',
  orangeVivid: '#F6A200',
  orangeBright: '#FFA500',
  orangeLight: '#F3B879',
  orangeRed: '#EF4723',
  orangeBrown: '#C89720',

  yellowOrange: '#FFAE42',
  yellowDarkest: '#FFFF00',
  yellowDarker: '#ffe300',
  yellowDark: '#f0c33b',
  yellow: '#ffd119',
  yellowBright: '#F8EE08',
  yellowGreen: '#D1EA13',
  yellowLight: '#ffffa6',
  yellowLighter: '#fbf4e8',
  yellowLightest: '#fdf8ef',
  yellowTranslucent: 'rgba(255,209,25,0.5)',
  dimYellow: '#F9E097',
  yellowBrown: '#FFC451',

  greenLight: '#92C04F',
  greenLighter: '#9DC661',
  green: '#719C4D',
  greenMuted: '#89A982',
  greenBright: '#00FF00',
  greenDark: '#427438',
  greenForest: '#147315',
  greenBlue: '#7fffd4',
  dimGreen: '#B7C69B',
  teal: '#15A697',
  tealBright: '#00CE9B',
  tealLight: '#D5F4EF',
  tealDark: '#24ABC3',
  brightGreen: '#2EB736',
  brightGreenLight: '#16FCCE',

  indigo: '#4C59C2',
  bluegreen: '#00FFFF',
  cornflowerBlue: '#6495ED',

  blueDarkest: '#3E4DA1',
  blueDarker: '#06437B',
  blueDark: '#0B549A',
  blueCobalt: '#2C7AC2',
  blue: '#2978C2',
  blueLight: '#81AED8',
  blueSoft: '#A5C7D8',
  bluePremium: '#B1C6D7',
  bluePremiumLight: '#C5D8E6',
  blueLighter: '#B5CAE3',
  bluePale: '#E9EFF1',
  bluePaler: '#EEF3F5',
  blueVeryDark: 'rgba(0,122,255,0.1)',
  blueLightest: '#EDF5F9',
  blueTranslucent: '#CEE2FF',
  dimBlue: '#EDF4F6',
  darkBlue: '#007AFF',
  lightBlue: '#E2F7F8',

  translucent: 'rgba(0,0,0,0.45)',
  translucentLightest: 'rgba(0,0,0,0.1)',
  translucentVeryLight: 'rgba(0,0,0,0.03)',
  translucentLighter: 'rgba(0,0,0,0.2)',
  translucentSoft: 'rgba(0,0,0,0.15)',
  translucentMedium: 'rgba(0,0,0,0.25)',
  translucentLight: 'rgba(0,0,0,0.3)',
  translucentDark: 'rgba(0,0,0,0.4)',
  translucentDarker: 'rgba(0,0,0,0.5)',
  veryLightGray: '#F4F4F4',
  pastelBlue: '#AFB4DF'
}

export const commercial: ColorPalette = {
  black: '#000000',
  grayDarker: '#333333',
  grayDark: '#666666',
  gray: '#818181',
  grayLight: '#BABBBD',
  grayLightest: '#F0EEEC',
  white: '#FFFFFF',

  greenDarker: '#446C26',
  green: '#5A9032',
  greenLight: '#639C38',
  greenLighter: '#9CBC84',

  grayBlue: '#3E515F',
  blueDark: '#003270',
  blue: '#335B89',
  blueLight: '#7297C1',
  blueLighter: '#3B64A5'
}

export const rthChart: ColorPalette = {
  blue: '#1F729D',
  brown: '#8C5402',
  magenta: '#AF18B8',
  teal: '#00DDC6',
  green: '#00870E',
  greenLight: '#15A697',
  yellow: '#C3AB1E',
  lavenderBlue: '#c5cbff',
  purple: '#6F27DB',
  purpleLight: '#a993cd',
  purpleLighter: '#d9b0fd',
  purpleLightest: '#c5cbff',
  paleRed: '#E16600',
  darkRed: '#450000',
  red: '#b62e00'
}

export const consumerRTHChart: ColorPalette = {
  cool: '#6BBEEA',
  coolStage2: '#1F729D',
  heat: '#FC6C68',
  heatStage2: '#BC1C10',
  heatStage3: '#E68B02',
  heatAux: '#FF9DA6',
  heatAuxStage2: '#FC6C68',
  heatAuxStage3: '#BC1C10',
  hoverBox: '#F0F0F0',
  hoverBoxBackground: '#F0F0F0',
  chartBackground: '#F3F7F8'
}

export const paywallFeatureCards: Record<string, PaywallFeatureCard> = {
  hehm: {
    accent: '#4C59C2',
    card: {
      gradientTopLeft: '#E3E5F3',
      gradientFiftyPercent: '#F8F8FB',
      gradientBottomRight: '#E3E5F3'
    },
    button: {
      gradientTopLeft: '#6E79D3',
      gradientFiftyPercent: '#9BA1D7',
      gradientBottomRight: '#8E96D9'
    },
    border: {
      gradientTopLeft: '#989BB4',
      gradientFiftyPercent: '#D2D5EC'
    }
  },
  premium: {
    accent: '#FF2B00',
    card: {
      gradientTopLeft: '#FFF9F7',
      gradientFiftyPercent: '#FFE6E1',
      gradientBottomRight: '#FFEBE7'
    },
    button: {
      gradientTopLeft: '#FF2B00',
      gradientFiftyPercent: '#FF7559',
      gradientBottomRight: '#FF2B00'
    }
  }
}
